// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-add-button[data-v-e10627f2] {\n  width: 1.5rem;\n  height: 1.5rem;\n}", ""]);
// Exports
module.exports = exports;
